export const FIELD_GROUPS = [
  { id: 'principal', title: 'Datos principales', primary: ['ID', 'FOLIO', 'EMPRESA', 'PROVEEDOR', 'TOTAL', 'MONTOSOLICITADO', 'DIVISA'] },
  { id: 'fechas', title: 'Fechas', fields: ['FECHA_ORDENCOMPRA', 'VENCIMIENTO', 'DIASRESTANTES', 'FECHA_CREACION', 'FECHA_VENCIMIENTO'] },
  { id: 'responsables', title: 'Responsables', fields: ['SOLICITANTE', 'COMPRADOR', 'DEPARTAMENTO', 'CENTROCOSTO', 'CC', 'SUCURSAL'] },
  { id: 'autorizaciones', title: 'Validaciones', fields: ['AUTNIVEL1', 'AUTNIVEL2', 'AUTNIVEL3', 'CONFIRMARPRECIO', 'CANCELADO_ERP'] },
  { id: 'otros', title: 'Otros', fields: ['ECONOMICO', 'NOTAS_REQUI', 'NOTAS', 'TIPO_PAGO'] },
];

export const COLUMN_LABELS = {
  ID: 'ID',
  FOLIO: 'Folio OC',
  PROVEEDOR: 'Proveedor',
  NUMEROCC: 'No. Centro Costo',
  CENTROCOSTOS: 'Centro de costo',
  CENTRO_COSTO: 'Centro de costo',
  DEPARTAMENTO: 'Departamento',
  AREA: 'Área',
  USER_NAME: 'Usuario ERP',
  NOMBRE: 'Usuario',
  FOLIO_FACTURA: 'Folio factura',
  FECHA_FACTURA: 'Fecha factura',
  FECHA_COMPROMISO: 'Fecha compromiso',
  PAGO: 'Tipo de pago',
  TIPO_PAGO: 'Tipo de pago',
  NUMERO_ECONOMICO: 'No. económico',
  IMPORTE: 'Importe OC',
  MONTOSOLICITADO: 'Monto solicitado',
  TOTAL: 'Total OC',
  ESTATUS: 'Estatus',
  ACTIVO: 'Activo',
  FECHA_CREACION: 'Fecha creación',
  FECHA_AUTORIZACION: 'Fecha autorización',
  FECHA_VENCIMIENTO: 'Fecha vencimiento',
  MONEDA: 'Moneda',
  PERFIL: 'Perfil',
  SOLICITANTE: 'Solicitante',
  AUTORIZA: 'Autoriza',
  EMPRESA: 'Empresa',
  DIVISA: 'Divisa',
  CC: 'No. CC',
  CENTROCOSTO: 'Centro de costo',
  ECONOMICO: 'No. económico',
  COMPRADOR: 'Comprador',
  CONFIRMARPRECIO: 'Precio Confirmado',
  NOTAS: 'Notas Partida',
  NOTAS_REQUI: 'Notas Requisición',
  VENCIMIENTO: 'Vencimiento',
  DIASRESTANTES: 'Días rest.',
  SUCURSAL: 'Sucursal',
  FECHA_ORDENCOMPRA: 'Fecha OC',
  CANCELADO_ERP: 'Activo ERP',
};

export const CANCELADO_ERP_BG = '#D5B6BE';

export const COLUMN_TYPES = {
  ACTIVO: 'boolean',
  CONFIRMARPRECIO: 'boolean',
  CANCELADO_ERP: 'boolean',
};

export const DEFAULT_STICKY_WIDTHS = {
  __expand__: 44,
  ID: 75,
  FOLIO: 105,
};
